import React, { useEffect, useState } from 'react'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { formatAmount } from '../../assets/javascript/formate-functions'
import FilterPromise from '../../components/user/finance/FilterPromise'


const PaymentPromises = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()


    useEffect(() => {
        accountingAxios.get('/v2/payment-promises', {
            params: {
                status: searchParams.get('status'),
                party_id: searchParams.get('party_id'),
                bill_no: searchParams.get('bill_no'),
                from_date: searchParams.get('from_date'),
                end_date: searchParams.get('end_date'),
                date_type: searchParams.get('date_type')
            }
        }).then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [searchParams.get('from_date'), searchParams.get('end_date'), searchParams.get('party_id'), searchParams.get('bill_no'),
    // eslint-disable-next-line
    searchParams.get('status'), searchParams.get('date_type')
    ])

    const filterModal = () => {
        setModal({
            status: true,
            title: "Filter",
            content: <FilterPromise setModal={setModal} />
        })
    }

    return (
        <div className="bills-list">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Payment Promises']}>
                {data[0] ? <TableFilter
                    topRight={<button onClick={filterModal}>Filter</button>}
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Creation Date</th>
                                <th>Party</th>
                                <th>Bill No</th>
                                <th>Promise Amount</th>
                                <th>Promise Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index} >
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/payment-promise/${item?.uuid}`)}  >
                                        {item?.date ? new Date(item?.date).toDateString() : ''}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/payment-promise/${item?.uuid}`)}  >
                                        {item?.party?.type} / {item?.party?.id}, {item?.party?.name}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/payment-promise/${item?.uuid}`)}  >
                                        {item?.bill_no} 
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/payment-promise/${item?.uuid}`)}  >
                                        ₹ {formatAmount(item?.promised_amount)}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/payment-promise/${item?.uuid}`)}  >
                                        {item?.promised_date ? new Date(item?.promised_date).toDateString() : ''}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/payment-promise/${item?.uuid}`)}  >
                                        {item?.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading}
                        bottomContent={<>
                            <button onClick={filterModal}>Filter</button>
                        </>} />
                }
            </SinglePage>
        </div >
    )
}

export default PaymentPromises